import * as React from "react";

class PaperworkEntryPrintTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.renderImageText = this.renderImageText.bind(this);
  }

  renderImageText(editedText, text) {
    if (editedText != null) {
      return <div dangerouslySetInnerHTML={this.createMarkup(editedText)} />;
    }
    if (text != null) {
      return <div dangerouslySetInnerHTML={this.createMarkup(text)} />;
    }
    return <div>This image doesn't contain text.</div>;
  }

  createMarkup(text) {
    return { __html: text };
  }

  getFullName(item) {
    if (item.fullName) {
      return item.fullName;
    } else if (item.firstName && item.lastName) {
      return `${item.firstName} ${item.lastName}`;
    }
    return "";
  }

  formatDate(date) {
    var d = new Date(date);
    return ("0" + d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" +
    d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
  }

  render() {
    const { paperworkEntries } = this.props;
    const newPage = {
      pageBreakAfter: "always"
    };

    return (
      <div>
        {paperworkEntries.map((paperworkEntry) => {    
            return  <div className="box box--med box--white box__shadow--1">
            {paperworkEntry.paperworkImageEntries.map((item, index) => {
              return (
                <div key={item.id}>
                  <div className="group">
                    <div className="logo" />
                    <div className="separator--primary spc--bottom--med"></div>
                  </div>
                  <div className="table--secondary">
                    <div className="table--secondary__cell first">
                      <strong>Printed on: </strong>
                    </div>
                    <div className="table--secondary__cell">{new Date().toDateString()}</div>
                  </div>
                  <div className="table--secondary">
                    <div className="table--secondary__cell first">
                      <strong>Entry Id: </strong>
                    </div>
                    <div className="table--secondary__cell">{paperworkEntry.id}</div>
                  </div>
                  <div className="table--secondary">
                    <div className="table--secondary__cell first">
                      <strong>Created On:</strong> 
                    </div>
                    <div className="table--secondary__cell">{this.formatDate(paperworkEntry.createdOn)}</div>
                  </div>
                  <div className="table--secondary">
                    <div className="table--secondary__cell first">
                      <strong> Patient name: </strong>
                    </div>
                    <div className="table--secondary__cell">{this.getFullName(paperworkEntry)}</div>
                    </div>
                  <div className="table--secondary">
                    <div className="table--secondary__cell first">
                      <strong>Date of service: </strong>
                    </div>
                    <div className="table--secondary__cell">{this.formatDate(paperworkEntry.dos)}</div>
                  </div>
                  <div className="table--secondary">
                    <div className="table--secondary__cell first">
                      <strong>Entry: </strong>
                    </div>
                    <div className="table--secondary__cell">{index + 1}/{paperworkEntry.paperworkImageEntries.length}</div>
                  </div>
                  <div className="table--secondary">
                    <div className="table--secondary__cell first">
                      <strong>Image name:</strong>
                    </div>
                    <div className="table--secondary__cell">{item.name}</div>
                  </div>
                  <div className="table--secondary">
  
                      <div className="table--secondary__cell first">
                        <strong>Image Text:</strong>
                      </div>
                      <div className="table--secondary__cell">{this.renderImageText(item.editedText, item.text)}
                      </div>
                  </div>
                  <div className="table--secondary">
                      <div className="table--secondary__cell first">
                        <strong>Image:</strong>
                      </div>
                      <div className="table--secondary__cell">
                        <img src={item.url} alt="Image"/>
                      </div>
                </div>
                <p style={newPage} />   
              </div>
              );
            })}
          </div>
          })
          }
      </div>
    );
  }
}

export { PaperworkEntryPrintTemplate };



// WEBPACK FOOTER //
// ./src/modules/paperwork-entry/components/PaperworkEntryPrintTemplate.js